import { Category } from './category.model';
import { City } from './city.model';
import { User } from './user.model';
import {  Street } from './street.model';
import { Zone } from './zone.model';
import {ServiceModel} from "./serviceModel.model";
import {Product} from "./product.model";
export interface IShop {
  id?: number;
  shopID?: string;
  name?: string;
  address?: string;
  zone?: Zone;
  city?: City;
  dateStartAuthorisation?: Date;
  dateEndAuthorisation?: Date;
  idNumberEnterprise?: string;
  createdAt?: Date;
  updatedAt?: Date;
  description?: string;
  photo?: string;
  photoAutorisation?: string;
  sellerId?: User;
  mobile?: string;
  fixe?: string;
  category?: Category;
  activated?: boolean;
  channelNumber?: string;
  channelName?: string;
  services?: ServiceModel[];
  products?: Product[];
}

export class Shop implements IShop {
  constructor(
    public id?: number,
    public shopID?: string,
    public name?: string,
    public address?: string,
    public zone?: Zone,
    public city?: City,
    public dateStartAuthorisation?: Date,
    public dateEndAuthorisation?: Date,
    public idNumberEnterprise?: string,
    public createdAt?: Date,
    public updatedAt?: Date,
    public description?: string,
    public photo?: string,
    public photoAutorisation?: string,
    public sellerId?: User,
    public mobile?: string,
    public fixe?: string,
    public category?: Category,
    public activated?: boolean,
    public channelNumber?: string,
    public channelName?: string,
    public services?: ServiceModel[],
    public products?: Product[]
  ) {
    this.id = id;
    this.shopID = shopID;
    this.name = name;
    this.address = address;
    this.zone = zone;
    this.city = city;
    this.dateStartAuthorisation = dateStartAuthorisation;
    this.dateEndAuthorisation = dateEndAuthorisation;
    this.idNumberEnterprise = idNumberEnterprise;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.description = description;
    this.photo = photo;
    this.photoAutorisation = photoAutorisation;
    this.sellerId = sellerId;
    this.mobile = mobile;
    this.fixe = fixe;
    this.category = category;
    this.activated = activated;
    this.channelNumber = channelNumber;
    this.channelName = channelName;
    this.services = services;
    this.products = products;
  }
}
